import { useState, useEffect } from "react";

const useScript = (url) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (url.includes("undefined") || !loading) {
      return;
    }
    setLoading(true);

    const script = document.createElement("script");
    script.src = url;
    script.async = true;

    script.onload = () => setLoading(false);
    script.onerror = () => {
      setLoading(false);
      setError(new Error(`Failed to load script: ${url}`));
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [url]);

  return { loading, error };
};

export default useScript;
